module.exports = __webpack_public_path__ + "static/media/Reforme.c5583927.jpg";